import { Link as RouterLink } from 'react-router-dom'
import { Link as MUILink } from '@mui/material'
import PropTypes from 'prop-types'

const Link = (props) => {
  const { to, ...rest } = props
  return <MUILink component={to ? RouterLink : undefined} to={to} {...rest} />
}

Link.propTypes = {
  to: PropTypes.string,
}

export default Link
